import { motion } from "framer-motion";
import { Compass, FileText, Plane, Home, PlaneLanding, ClipboardCheck } from "lucide-react";
import { SERVICES } from "@/lib/data";
import { fadeUp, stagger, viewport } from "@/lib/motion";

const ICONS = [Compass, ClipboardCheck, FileText, Plane, Home, PlaneLanding];

export default function Services() {
  return (
    <section id="hizmetler" data-testid="services-section" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-2xl mb-14">
          <span className="text-sm uppercase tracking-[0.2em] text-[#1B19A8] font-semibold">Hizmetlerimiz</span>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-[#1a1a1a] mt-4 leading-tight">
            Baştan sona <span className="text-[#1B19A8]">yanındayız.</span>
          </h2>
        </div>

        <motion.div
          variants={stagger}
          initial="hidden"
          whileInView="show"
          viewport={viewport}
          className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5"
        >
          {SERVICES.map((s, i) => {
            const Icon = ICONS[i] || Compass;
            return (
              <motion.div
                key={s.title}
                variants={fadeUp}
                custom={i}
                whileHover={{ y: -4 }}
                className="rounded-3xl bg-[#f7f9fa] border border-black/5 p-8 hover:border-[#1B19A8]/25 transition-colors"
              >
                <span className="grid place-items-center w-12 h-12 rounded-2xl bg-[#1B19A8]/8 text-[#1B19A8] mb-5">
                  <Icon size={24} strokeWidth={2} />
                </span>
                <h3 className="font-display text-lg font-bold text-[#1a1a1a] mb-2">{s.title}</h3>
                <p className="text-[#1a1a1a]/60 leading-relaxed text-sm">{s.text}</p>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
}
